import styled from "styled-components";
import WithDirection from "../../../../settings/withDirection";

const CommunitySwitcherWrapper = styled.div`

.ubCommunityAvatarWrapper {
  height: 100%;
  padding: 10px 10px 10px 10px;
}

.selectCommunityCheckboxWrapper{
  display: flex;
  flex-direction: column;
  background-color: red;
  justify-content: flex-start;
  align-items: center;
}

  
`;

export default WithDirection(CommunitySwitcherWrapper);
